// extracted by mini-css-extract-plugin
export default {"formContainer":"AddMedic_formContainer__CIKXx","formBtn":"AddMedic_formBtn__D0I4z"};